import { Breadcrumb } from "@project/shared";
import { useRouter } from "next/router";
import FAQAndCommitment from "../../component/molecules/FaqAndCommitment";
import { FacilityTop } from "../../component/organism";
import { styled } from "linaria/lib/react";
import { Result, Spin } from "antd";
import { GetUserContentsByID } from "../../service/content";
import { useQuery } from "react-query";
import React, { useEffect } from "react";
import Head from "next/head";
import { GetServerSideProps } from "next";
import { useTranslation } from "react-i18next";
import ContactUsCard from "../../component/organism/ContactUsCard";
import FacilityContentCard from "../../component/organism/FacilityContentCard";
const CustomSpinner = /*#__PURE__*/styled(Spin)({
  name: "CustomSpinner",
  class: "ccwiar0"
});

const Facilities = props => {
  const router = useRouter();
  const {
    t
  } = useTranslation();
  const {
    id
  } = router.query;

  if (!id) {
    return <CustomSpinner />;
  }

  const {
    data: content
  } = useQuery(["user--list-by-id", id], () => GetUserContentsByID(id), {
    initialData: props?.content?.data,
    enabled: id ? true : false,
    refetchOnWindowFocus: false
  });

  if (content?.data?.length === 0) {
    return <Result status="404" subTitle={t("Record not found")} />;
  }

  useEffect(() => {
    const view = process.browser && document.getElementById(localStorage.getItem("tabIndex"));

    if (view) {
      const yOffset = localStorage.getItem("tabIndex") === "others" ? window.innerWidth > 768 ? 100 : -150 : -150;
      const y = view.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: "smooth"
      });
      localStorage.removeItem("tabIndex");
    }
  }, []);
  return <>
      <Head>
        <title>{`${props?.data[0]?.name} (${props?.data[0]?.prefecture}) | オフサイトミーティングを一括手配：コワーケーション.com`}</title>
        <meta name="keywords" content={`${props?.data[0]?.name},${props?.data[0]?.prefecture},コワーケーション,合宿,研修,オフサイトミーティング,チームビルディング,役員合宿,`} />
        <meta key="facilities_description_image" property="og:image" content={props?.data[0]?.coverImage} />
        <meta key="facilities_og_url" property="og:url" content={`https://co-workation.com/facilities/${id}`} />
        <meta key="facility_title" property="og:title" content={`${props?.data[0]?.name} (${props?.data[0]?.prefecture}) | オフサイトミーティングを一括手配：コワーケーション.com`} />
        <meta name="description" property="og:description" content={`${props?.data[0]?.name} (${props?.data[0]?.prefecture}) での合宿・研修のご紹介。${props?.data[0]?.contentTitle}。${props?.data[0]?.descriptionTitle}。コワーケーション.comでは、法人の合宿・研修のために、全国の施設と研修・体験コンテンツを代行して一括手配いたします。`} />
        <meta key="facility-Description" property="description" content={`${props?.data[0]?.name} (${props?.data[0]?.prefecture}) での合宿・研修のご紹介。${props?.data[0]?.contentTitle}。${props?.data[0]?.descriptionTitle}。コワーケーション.comでは、法人の合宿・研修のために、全国の施設と研修・体験コンテンツを代行して一括手配いたします。`} />
        <meta name="robots" content="index, follow" />
      </Head>

      <>
        <FacilityTop id={id} data={props?.data || []} />
        <FAQAndCommitment />
        <ContactUsCard />
        <FacilityContentCard />
        <Breadcrumb items={[{
        name: "トップ",
        href: "/"
      }, {
        name: content?.data[0]?.name || "-"
      }]} />
      </>
    </>;
};

export const getServerSideProps: GetServerSideProps = async context => {
  const {
    id
  } = context?.query;
  const content = await GetUserContentsByID(id);
  return {
    props: content
  };
};
export default Facilities;

require("./[id].linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./[id].tsx");